export const envObj = {
  dev: {
    translate: '172.20.200.31:5000',
    auth: '172.20.200.30:9544',
    upms: '172.20.200.30:9544',
    marketing: '172.20.200.30:9544',
    moriDataSys: '172.20.200.30:9544',
    erp: '172.20.200.30',
  },
  test: {
    translate: '172.20.200.31:5000',
    auth: 'dyt.pms.com.cn:9544',
    upms: 'dyt.pms.com.cn:9544',
    marketing: 'dyt.pms.com.cn:9544',
    moriDataSys: 'dyt.pms.com.cn:9544',
    erp: 'testing.lapa.com.cn',
  },
  prod: {
    translate: 'translate.lapa.com.cn',
    auth: 'sso.lapa.com.cn',
    upms: 'sso.lapa.com.cn',
    marketing: 'sales.lapa.com.cn',
    moriDataSys: 'dc.lapa.com.cn',
    erp: 'erp.lapa.com.cn',
  }
};
export const envConstant = {
  dev: {
    VUE_APP_BROADCASTKEY: 'broadcastMessage',
    VUE_APP_SYSTEMCODE: 'lapa-erp',
  },
  test: {
    VUE_APP_BROADCASTKEY: 'broadcastMessage',
    VUE_APP_SYSTEMCODE: 'lapa-erp',
  },
  prod: {
    VUE_APP_BROADCASTKEY: 'broadcastMessage',
    VUE_APP_SYSTEMCODE: 'lapa-erp',
  }
};
// 指定测试环境所包含的 host
export const appointTestHost = ['testing.lapa.com.cn', '172.20.200.14:9544'];
// 指定开发环境所包含的 host
export const appointDevHost = ['172.20.200.30'];
